import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "crm:mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "crm:flex crm:mt-4 crm:justify-end"
}

import {inject, reactive, onMounted, ref, provide,toRefs,watch} from "vue";
import AppChecklistModelloItem from "./AppChecklistModelloItem.vue";
import AppChecklistModello from "../checklist-modello/AppChecklistModello.vue";
import BaseControlModal from "../../components/BaseControlModal.vue";
import {useDefineModal} from "../../composable/definer/useDefineModal";


export default {
  __name: 'AppChecklistModelli',
  props: {
  /**
   * Se true permette di modificare/eliminare un modello
   */
  is_editable: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelloSelezionato', 'open:dettaglio'],
  setup(__props, { emit: __emit }) {

/**
 * @doc
 * Questo componente recupera e renderizza la lista di modelli checklist.
 * Gestisce anche il cambio modello e la cancellazione modello
 */
const emits = __emit
const $DesignSystem = inject('$DesignSystem')
const $AxiosClient = inject('$AxiosClient');
const props = __props

const templates = reactive({
  list: [],
  listDefault: [],
  modelloAttivo: null,
  // se true mostra la modale di controllo cancellazione modello
  isModalCancellazioneModello: false,
  // se true mostra la modale per l'aggiornamento del modello
  isModalAggiornaModello: false,
  // se popolato, contiene la ricerca modelli effettuata
  ricerca: {value: null}
})

onMounted(async() => await reloadModelli())

/**
 * recupero la lista dei modelli salvati
 * @return {Promise<void>}
 */
async function reloadModelli() {
  let getModelliChecklist = await $AxiosClient.post('Questionari', 'getModelli', null, {messages: 'error'})
  if(getModelliChecklist && getModelliChecklist.esito === 'ok') {
    templates.list = getModelliChecklist.rows
    templates.listDefault = getModelliChecklist.rows
  }
}

const modelloSelezionato = ref(null)

/**
 * Gestisce la selezione/deselezione del modello attivo.
 * Vi può essere un solo modello attivo. Quando se ne attiva uno, gli altri vengono in automatico deselezionati
 * @param modelloID
 * @return {*|null}
 */
const aggiornaModelloSelezionato = (modelloID) => {
  modelloSelezionato.value = modelloID
  let modello = (templates.list).reduce((result, item) => {
    return item.modello_id['$oid'] === modelloID ? item : result
  }, null);
  templates.modelloAttivo = modello;
  emits('update:modelloSelezionato', modello)
};

const openDetail = (elements) => emits('open:dettaglio', elements)
provide('openDetail', openDetail)

/**
 * Chiude la modale di controllo cancellazione
 * Esegue la chiamata ajax per la cancellazione del modello
 * Ricarica la lista dei modelli
 * @return {Promise<void>}
 */
async function eliminaModello() {
  templates.isModalCancellazioneModello = false;
  await $AxiosClient.post('Questionari', 'deleteModello', {modello_id: templates.modelloAttivo.modello_id.$oid}, {messages: false})
  modelloSelezionato.value = null;
  await reloadModelli();
}

/**
 * Dopo l'aggiornamento del modello chiude la modale e riaggiorna l'elenco dei modelli
 * E riaggiorna i dati del modello attivo
 * @return {Promise<void>}
 */
async function onDopoAggiornamentoModello() {
  templates.isModalAggiornaModello = false;
  let modelloAttivo = templates.modelloAttivo;
  templates.modelloAttivo = null;
  await reloadModelli();
  let getModelloAttivoAggiornato = Object.values(templates.list).filter((element) => {
    if(element.modello_id['$oid'] === modelloAttivo.modello_id['$oid']) return element
  })
  templates.modelloAttivo = getModelloAttivoAggiornato[0]
}

const {ricerca} = toRefs(templates)
watch(ricerca, (newValue) => {
  let modelloCercato = newValue.value;
  if(modelloCercato && modelloCercato !== '') templates.list = (templates.list).filter(item => (item.title.toLowerCase()).includes(modelloCercato.toLowerCase()));
  if(!modelloCercato || modelloCercato === '') templates.list = templates.listDefault
}, {deep: true})

const modaleAggiornaModello = useDefineModal('aggiorna_modello_checklist', 'Aggiorna Modello', false)

/**
 * Aggiorna il titolo con il nome del modello selezionato e apre la modale
 */
function apriModaleAggiornaModello() {
  modaleAggiornaModello.changeTitle(`Aggiorna Modello ${templates.modelloAttivo.title}`)
  modaleAggiornaModello.open()
}

return (_ctx, _cache) => {
  const _component_base_input_text_floating_label = _resolveComponent("base-input-text-floating-label")
  const _component_base_choice_item = _resolveComponent("base-choice-item")
  const _component_base_choice = _resolveComponent("base-choice")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_modal = _resolveComponent("base-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "modelli-title", {}, () => [
      _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "crm:uppercase crm:text-sm crm:font-bold" }, "Scegli un modello:", -1 /* CACHED */))
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_input_text_floating_label, {
        label: "Ricerca modelli",
        "validate-to": templates.ricerca,
        "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((templates.ricerca) = $event)),
        name: "ricerca_modelli"
      }, null, 8 /* PROPS */, ["validate-to"])
    ]),
    _createVNode(_component_base_choice, { "onGet:activeChoice": aggiornaModelloSelezionato }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.list, (template, templateKey) => {
          return (_openBlock(), _createBlock(_component_base_choice_item, {
            key: templateKey,
            id: template.modello_id['$oid'],
            class: "crm:bg-ternary"
          }, {
            default: _withCtx(() => [
              _createVNode(AppChecklistModelloItem, {
                selected: modelloSelezionato.value === template.modello_id['$oid'],
                modello: template
              }, null, 8 /* PROPS */, ["selected", "modello"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }),
    (__props.is_editable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_base_button, {
            mode: "confirm",
            class: "crm:mr-2!",
            state: modelloSelezionato.value ? 'active': 'disable',
            "onClick:cta": _cache[1] || (_cache[1] = $event => (apriModaleAggiornaModello()))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Aggiorna modello ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state"]),
          _createVNode(_component_base_button, {
            mode: "error",
            state: modelloSelezionato.value ? 'active': 'disable',
            "onClick:cta": _cache[2] || (_cache[2] = $event => (templates.isModalCancellazioneModello = true))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Cancella modello ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state"])
        ]))
      : _createCommentVNode("v-if", true),
    (templates.isModalCancellazioneModello)
      ? (_openBlock(), _createBlock(BaseControlModal, {
          key: 1,
          message: `del modello ${templates.modelloAttivo.title}`,
          "onConfirm:control": eliminaModello,
          "onClose:control": _cache[3] || (_cache[3] = $event => (templates.isModalCancellazioneModello = false))
        }, null, 8 /* PROPS */, ["message"]))
      : _createCommentVNode("v-if", true),
    (templates.modelloAttivo && _unref(modaleAggiornaModello).getShow())
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 2,
          title: _unref(modaleAggiornaModello).getTitle(),
          id: _unref(modaleAggiornaModello).getId(),
          "onModal:closed": _cache[4] || (_cache[4] = $event => (_unref(modaleAggiornaModello).close()))
        }, {
          default: _withCtx(() => [
            _createVNode(AppChecklistModello, {
              "onUpdate:model": onDopoAggiornamentoModello,
              modelloChecklist: templates.modelloAttivo
            }, null, 8 /* PROPS */, ["modelloChecklist"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title", "id"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}